import axios from 'axios'
import { endpoints } from './endpoints';

const projectEndpoints = endpoints.project;

export function add(data: any){
  return axios.post(projectEndpoints.getAll(), data)
}

export function update(projectId: string, data: any){
  return axios.patch(projectEndpoints.getOne(projectId), data)
}

export function delete_(projectId: string){
  return axios.delete(projectEndpoints.getOne(projectId))
}

export function regenerateAPIAccess(projectId: string){
  return axios.post(projectEndpoints.regenerateAPIAccess(projectId))
}

export function updateSetting(projectId: string, type: string, data: any){
  return axios.patch(projectEndpoints.updateSetting(projectId, type), data)
}

export function getAPIRequestLogs(projectId: string, startDt: string, endDt: string, timezoneOffset: number) {
  return axios.post(projectEndpoints.getAPIRequestLogs(projectId), {start_dt:startDt, end_dt:endDt, timezone_offset:timezoneOffset})
}

export function getModels(projectId: string) {
  return axios.get(projectEndpoints.getModels(projectId))
}